import AppContainer from './container';

export default AppContainer;
